import PageLang from '../../utils/page-lang';
import Popup from '../../utils/popup';

class Terminy {
    constructor() {
        //this._subscriptionSettings = window.ustawieniaAbonamentu || {};
        this.input = $('.abonaments__dates__item input');
        this.form = $('#abonaments-dates');
        this.submitButton = $('.submit-terminy');
        this._selectedDate = null;
        this._selectedDates = [];
        this.removeSelectedDateButton = '.cart__item__row__trash';
        this._indexOfGroup = 0;
        this.translates = {
            //blad_podczas_blokowania_terminow: {
            //    pl: 'Wystąpił błąd podczas blokowania terminów!',
            //    en: 'An error happened when trying to lock terms!'
            //}
        };
    }

    //get subscriptionSettings() {
    //    return this._subscriptionSettings;
    //}

    //set subscriptionSettings(obj) {
    //    Object.assign(this._subscriptionSettings, obj);
    //}

    get selectedDate() {
        return this._selectedDate;
    }

    set selectedDate(value) {
        this._selectedDate = value;
    }

    get selectedDates() {
        return this._selectedDates;
    }

    set selectedDates(value) {
        this._selectedDates = value;
        this.showSelectedDates();
        this.addClassToGroupOfSelectedDates();
    }

    get indexOfGroup() {
        return this._indexOfGroup;
    }

    set indexOfGroup(value) {
        this._indexOfGroup = value;
    }

    events() {
        const _this = this;

        _this.input.off('change').on('change', function (event) {
            _this.selectedDate = $(this);
            _this.selectGroup(event);
        });

        $(document).on('click', this.removeSelectedDateButton, function () {
            _this.removeSelectedDateFromTheSummary($(this).attr('data-termin-id'));
        });

        this.form.on('submit', function (event) {
            event.preventDefault();
            //let result = _this.validation(event);
            let result = _this.validation();

            let selectedTermsIds = [];
            $.each(_this.selectedDates, function (index, row) {
                selectedTermsIds.push($(row).val());
            });
            let params = {
                id_terminow: selectedTermsIds,
                liczba_blokad: $('#abonaments__count').val()
            };
            if (result) {
                _this.lockTerms(params);
            }
        });

        $('.abonaments__dates__item').on('click', function () {
            console.log('bloczek kliknięty');
            let checkbox = $(this).find('input[type="checkbox"]');
            if ($(checkbox).is(':checked')) {
                console.log('checked');
                $(checkbox).prop('checked', false);
            } else {
                console.log('not checked');
            }
        });

        // this.submitButton.on("", function(event) {
        //   _this.validation(event);
        // });
    }

    lockTerms(params) {
        const _this = this;
        $.ajax({
            url: '/karnety/terminy.html',
            method: 'get',
            data: $.extend(
                {
                    ajax: 'dodaj_terminy_do_abonamentu',
                    definicja: id_definicji
                },
                params
            ),
            success: function (result) {
                if (result && result.status === 'success') {
                    let wybraneTerminyId = result.data.terminyWAbonamencie;
                    if (
                        _this.validation()
                    ) {
                        window.location.href =
                            '/karnety/obiekt.html?definicja=' + id_definicji;
                    }
                } else {
                    let popup = new Popup(result.message || translates.blokowanie_terminow_blad);
                    popup.showPopup();
                }
            },
            error: function (xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    setSubscriptionSettingsIfUndefined() {
        if (!min_terminow) {
            min_terminow = 1;
        }
        if (!max_terminow) {
            max_terminow = 999;
        }

        if (!min_terminow_grupa) {
            min_terminow_grupa = 1;
        }
        if (!max_terminow_grupa) {
            max_terminow_grupa = 999;
        }
    }

    selectGroup(event) {
        const _this = this;
        let selectedDate = this.selectedDate;
        if (min_terminow_grupa > max_terminow_grupa) {
            event.preventDefault();
            throw new Error('Bład grup: min nie może być większe od max!');
        }

        let numberOfSelectedGroups = $('input[type=checkbox]:checked').parents(
            '.abonaments__dates__row'
        ).length;
        let group = '.abonaments__dates__row';
        let selectedGroup = selectedDate.parents(group);

        let indexOfSelectedGroup = selectedGroup.index();

        // Klikniecie w inną grupę(wydarzenie)
        if (this.indexOfGroup !== indexOfSelectedGroup) {
            if (max_terminow === 1) {
                $('input[type=checkbox]:checked')
                    .data('isClicked', 0)
                    .prop('checked', false);

                numberOfSelectedGroups = 0;
            }
        }

        this.indexOfGroup = indexOfSelectedGroup;

        if (numberOfSelectedGroups <= max_terminow) {
            this.selectDateInGroup(event);
        } else {
            event.preventDefault();
            let notification = `Można wybrać maksymalnie ${max_terminow} ${_this.changeOfWord(
                max_terminow,
                'spektakl'
            )} w ramach abonamentu.`;

            this.showNotification(notification);
            return false;
        }
    }

    // Dodanie klasy do grupy(wydarzenia) w której sa zaznaczone terminy.
    addClassToGroupOfSelectedDates() {
        let group = '.abonaments__dates__row';

        $(group).removeClass('active');
        this.selectedDates.each(function (index, element) {
            let elementGroup = $(element).parents(group);

            if (!elementGroup.hasClass('active')) {
                elementGroup.addClass('active');
            }
        });
    }

    // Zaznaczanie dat w obrębie grupy(wydarzenia).
    selectDateInGroup(event) {
        const _this = this;
        let selectedDate = this.selectedDate;
        let min = min_terminow;
        let max = max_terminow;
        let minGrupa = min_terminow_grupa;
        let maxGrupa = max_terminow_grupa;

        if (min > max) {
            event.preventDefault();
            throw new Error('Bład grupy: min nie może być większe od max!');
        }

        let numberOfSelectedDatesInGroup = selectedDate
            .parents('.abonaments__dates__slider')
            .find('input[type=checkbox]:checked').length;
        if (maxGrupa === 1) {
            if (selectedDate.data('isClicked')) {
                selectedDate.data('isClicked', 0).prop('checked', false);

                let selectedTermsIds = [];
                $.each($('input[type=checkbox]:checked'), function (index, row) {
                    selectedTermsIds.push($(row).val());
                });
                let params = {
                    id_terminow: selectedTermsIds,
                    liczba_blokad: $('#abonaments__count').val()
                };
                _this.lockTerms(params);
            } else {
                selectedDate
                    .parents('.abonaments__dates__slider')
                    .find('input[type=checkbox]:checked')
                    .data('isClicked', 0)
                    .prop('checked', false);

                selectedDate
                    .data({
                        isClicked: 1
                    })
                    .prop('checked', true);
            }
        } else {
            if (numberOfSelectedDatesInGroup > max) {
                let notification = `Można wybrać maksymalnie ${max} termin w ramach spektaklu.`;

                this.showNotification(notification);
                event.preventDefault();
                return false;
            } else {
                if (selectedDate.data('isClicked')) {
                    selectedDate.data('isClicked', 0).prop('checked', false);
                } else {
                    selectedDate
                        .data({
                            isClicked: 1
                        })
                        .prop('checked', true);
                }
            }
        }
        this.selectedDates = $('input[type=checkbox]:checked');
    }

    showSelectedDates() {
        let html = '<h2>' + translates.podsumowanie_wyboru + '</h2>' +
            '<div id="cart-items">';

        if (this.selectedDates.length > 0) {
            this.selectedDates.each(function (index, element) {
                let name = $(element)
                    .parents('.abonaments__dates__slider')
                    .prev()
                    .text();
                let date =
                    $(element)
                        .next()
                        .find('.date')
                        .text() +
                    ', ' +
                    $(element)
                        .next()
                        .find('.day')
                        .text();
                let id = $(element).attr('data-termin-id');

                html += '<div class="cart__item__row">' +
                    '<div class="cart__item__row__name">' + name + '</div>' +
                    '<div class="cart__item__row__date">' + date + '</div>' +
                    '<span class="cart__item__row__trash icon icon_remove confirm" data-termin-id="' + id + '"></span>' +
                    '</div>';
            });

            html += '</div>' +
                '<div class="cart__item__foot">' +
                '<button type="submit" class="btn btn--large btn--brown submit-terminy">' + translates.dalej + '</button>' +
                '</div>';
        } else {
            html += '</div>' +
                '<div class="cart__item__foot">' +
                '<button type="submit" class="btn btn--large btn--grey submit-terminy">' + translates.dalej + '</button>' +
                '<div class="cart__item__foot__note">' + translates.nalezy_wybrac_daty + '</div>' +
                '</div>';
        }

        $('#abonaments-dates-side').html(html);
    }

    removeSelectedDateFromTheSummary(id) {
        const _this = this;
        let selectedDate = $('input[data-termin-id="' + id + '"]');

        selectedDate.data('isClicked', false).prop('checked', false);
        this.selectedDates = $('input[type=checkbox]:checked');

        let selectedTermsIds = [];
        $.each(_this.selectedDates, function (index, row) {
            selectedTermsIds.push($(row).val());
        });
        let params = {
            id_terminow: selectedTermsIds,
            liczba_blokad: $('#abonaments__count').val()
        };
        _this.lockTerms(params);
    }

    //validation(event) {
    validation() {
        const _this = this;
        let valid = true;
        let numberOfSelectedDatesInGroups = []; //dla wszystkich grup
        let numberOfSelectedDatesInGroups4active = []; // tylko dla tych gdzie jakiś termin jest zaznaczony - potrzebne do validacji


        let groups = $('.abonaments__dates__row');
        let checkbox;

        $.each(groups, function (gr_index, gr) {
            checkbox = $(gr).find('input[type="checkbox"]');
            if ($(checkbox).is(':checked')) {
                let row = $(gr).closest('.abonaments__dates__row');
                $(row).addClass('active');
            }
        });
        let selectedGroups = $('.abonaments__dates__row.active');
        let notification = `Musisz wybrać minimalnie ${min_terminow} ${this.changeOfWord(
            min_terminow,
            'termin'
        )} w ramach abonamentu i minimalnie ${min_terminow_grupa} ${this.changeOfWord(
            min_terminow_grupa,
            'spektakl'
        )} w wydarzeniu aby przejść dalej.`;

        if (selectedGroups.length === 0) {
            //nic nie zostało zaznaczone
            valid = false;
            //this.showNotification(notification);
        }

        groups.each(function () {
            let length = $(this).find('input[type=checkbox]:checked').length;

            numberOfSelectedDatesInGroups.push(length);
        });

        selectedGroups.each(function () {
            let length = $(this).find('input[type=checkbox]:checked').length;
            numberOfSelectedDatesInGroups4active.push(length);
        });

        // let matched = numberOfSelectedDatesInGroups.filter(function(value) {
        //   return value < min_terminow;
        // });

        // if (numberOfSelectedDatesInGroups.length < gmin) {
        //   valid = false;
        //   this.showNotification(notification);
        //   //event.preventDefault();
        // }

        // if (matched.length > 0) {
        //   valid = false;
        //   this.showNotification(notification);
        //
        // }
        let selectedTermsInAbonament = 0;

        $.each(numberOfSelectedDatesInGroups4active, function (
            index,
            selectedInGroupTotal
        ) {
            selectedTermsInAbonament += selectedInGroupTotal;
            if (selectedInGroupTotal < min_terminow_grupa || selectedInGroupTotal > min_terminow_grupa) {
                // w obrębie wydarzenia zostało wybrane za mało terminów lub za dużo
                valid = false;
                if (selectedInGroupTotal < min_terminow_grupa) {
                    notification = `Należy wybrać co najmniej ${min_terminow_grupa} ${_this.changeOfWord(
                        min_terminow_grupa,
                        'spektakl'
                    )} w ramach jednego wydarzenia.`;
                }
                if (selectedInGroupTotal > max_terminow_grupa) {
                    notification = `Można wybrać maksymalnie ${max_terminow_grupa} ${_this.changeOfWord(
                        max_terminow_grupa,
                        'spektakl'
                    )} w ramach jednego wydarzenia.`;
                }
            }
        });

        if (selectedTermsInAbonament < min_terminow || selectedTermsInAbonament > max_terminow) {
            // w abonamencie wybrano za mało terminów lub za dużo
            valid = false;
            if (selectedTermsInAbonament < min_terminow) {
                notification = `Należy wybrać co najmniej ${min_terminow} ${_this.changeOfWord(
                    min_terminow,
                    'spektakl'
                )} w ramach abonamentu.`;
            }
            if (selectedTermsInAbonament > max_terminow) {
                notification = `Można wybrać maksymalnie ${max_terminow} ${_this.changeOfWord(
                    max_terminow,
                    'spektakl'
                )} w ramach abonamentu.`;
            }
        }

        if (valid) {
            notification = '';
        } else {
            _this.showNotification(notification);
        }
        return valid;
    }

    showNotification(text) {
        let notificationElement = $('.cart__item__foot');
        let html = `<button type="submit" class="btn btn--large btn--grey">Dalej</button>
                <div class="cart__item__foot__note">${text}</div>`;

        notificationElement.html(html);
    }

    changeOfWord(quantity, word) {
        let suffixList = {
            termin: {
                _1: 'y',
                _2: 'ów'
            },
            spektakl: {
                _1: 'e',
                _2: 'i'
            }
        };

        let returnWorld = word;

        if (quantity > 1) {
            returnWorld = word + suffixList[word]['_2'];
        }

        if (
            $.inArray(quantity, [
                2,
                3,
                4,
                22,
                23,
                24,
                32,
                33,
                34,
                42,
                43,
                44,
                52,
                53,
                54,
                62,
                63,
                64
            ]) !== -1
        ) {
            returnWorld = word + suffixList[word]['_1'];
        }

        return returnWorld;
    }

    //jeśli mamy dużo termnów w rzędzie a nasz wybrany termin jest "gdzieś daleko", czyli niewidoczny
    //to przy przeładowaniu strony przewijamy listę tak aby był widoczny
    makeSelectedVisible() {
        function switchNext() {
            let checkbox;
            let nextButton;
            let terminyQty;
            $.each($('.abonaments__dates__slider'), function (index, row) {
                terminyQty = 0;
                $.each($(row).find('.abonaments__dates__item'), function (
                    termin_index,
                    terminBox
                ) {
                    terminyQty++;
                    checkbox = $(terminBox).find('input[type="checkbox"]');
                    if (
                        $(checkbox).length === 1 &&
                        $(checkbox).is(':checked') &&
                        $(terminBox).attr('aria-hidden') === 'true'
                    ) {
                        nextButton = $(terminBox)
                            .parent()
                            .parent()
                            .parent()
                            .find('.slick-next');
                        if ($(nextButton).length === 1) {
                            $(nextButton).click();
                            setTimeout(switchNext, 200);
                        }
                    }
                });

                //jak mamy jeden termin to dziwnie się wyświetla na mobile. Ten kod ma to poprawić
                if (terminyQty === 1 && $('body').hasClass('mobile')) {
                    $(row)
                        .find('.slick-track')
                        .css({width: $(row).width() + 'px'});
                    $(row)
                        .find('.abonaments__dates__item')
                        .css({width: $(row).width() + 'px'});
                }
            });
        }

        setTimeout(switchNext, 500);
    }

    applyMobilePageSettings() {
        let headerHeight = $('header').height();
        $('.abonaments__dates__wrapper').css('padding-top', headerHeight);
        $('.abonaments__dates__head').css({
            'margin-left': '-15px',
            'margin-right': '-15px'
        });
        // setTimeout(function(){
        //
        // }, 1000)
    }

    initSlick() {
        if (
            $(".abonaments__dates__slider").length > 0 &&
            $($(".abonaments__dates__slider").find(".abonaments__dates__item")).length > 0
        ) {
            $(".abonaments__dates__slider").each(function () {
                $(this).slick({
                    infinite: false,
                    slidesToShow: 3,
                    prevArrow: '<button type="button" class="slick-prev"></button>',
                    nextArrow: '<button type="button" class="slick-next"></button>',
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 301,
                            settings: {
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: 300,
                            settings: "unslick"
                        }
                    ]
                });
            });
        }
    }

    init() {
        this.initSlick();
        this.events();
        this.selectedDates = $('input[type=checkbox]:checked');
        this.showSelectedDates();

        if ($('body').hasClass('mobile')) {
            this.applyMobilePageSettings();
        }

        this.makeSelectedVisible();

        if($('body').hasClass('rezerwacja-karnety-terminy')) {
            this.setSubscriptionSettingsIfUndefined();
        }
    }
}

export default Terminy;